import * as React from 'react';
import { connect } from 'react-redux';

import PersonalPreference from './PersonalPreference';
import RelatedUsers from './RelatedUsers';
import PersonalAOI from './PersonalAOI';
import PersonalURL from './PersonalURL';
import PersonalItem from './PersonalItem';
import PersonalArea from './PersonalArea';

import * as findUserActions from '../../actions/findUser';
import * as AuthCreators from '../../creators/auth';
import * as MapActions from '../../actions/map';
import * as Const from '../../constants';

import {
  userInfoTableHeaders$,
  firstUserInfoItem$,
  preferenceItems$,
  preferenceValue$,
  percentageOfPreference$,
} from '../../selectors/findUser';

import getUserId from '../../selectors/getUserId';

import State from '../../interfaces/states/State';
import UserInfo from '../../interfaces/UserInfo';

interface DispatchProps {
  fetchFindUserAuthIdAction: (id: string) => void;
  fetchRefreshAuth: (firstLoad: boolean) => void;
  fetchMapShow: () => void;
}

interface OwnProps {
  userInfoData: UserInfo[];
  getUserId: number;
  userInfoTableHeaders: string[];
  firstUserInfoItem: UserInfo;
  preferenceItems: string[];
  preferenceValue: any[];
  percentageOfPreference: number[];
}

interface Props extends DispatchProps, OwnProps {}

function PersonalInformationTable (props: Props) {
  
  const {
    userInfoTableHeaders,
    firstUserInfoItem,
    preferenceItems,
    preferenceValue,
    fetchFindUserAuthIdAction,
    fetchRefreshAuth,
    percentageOfPreference,
  } = props;

  return (
    userInfoTableHeaders.map((tableHeadItem, key) => {
      if (tableHeadItem === Const.PERSONAL_PREFERENCE) {
        return (
          <React.Fragment key={key}>
            <PersonalPreference
              percentageOfPreference={percentageOfPreference}
              preferenceValue={preferenceValue}
              tableHeadItem={tableHeadItem}
              preferenceItems={preferenceItems} />
          </React.Fragment>
        );
      } else if (tableHeadItem === Const.PERSONAL_RELATED_USERS) {
        return (
          <React.Fragment key={key}>
            <RelatedUsers
              fetchFindUserAuthIdAction={fetchFindUserAuthIdAction}
              fetchRefreshAuth={fetchRefreshAuth}
              tableHeadItem={tableHeadItem}
              firstUserInfoItem={firstUserInfoItem} />
          </React.Fragment>
        );
      } else if (tableHeadItem === Const.PERSONAL_AREA) {
        return (
          <React.Fragment key={key}>
            <PersonalArea
              tableHeadItem={tableHeadItem}
              firstUserInfoItem={firstUserInfoItem} />
          </React.Fragment>
        );
      } else if (tableHeadItem === Const.PERSONAL_SAVED_AOI) {
        return (
          <React.Fragment key={key}>
            <PersonalAOI
              tableHeadItem={tableHeadItem}
              firstUserInfoItem={firstUserInfoItem} />
          </React.Fragment>
        );
      } else if (tableHeadItem.indexOf(Const.URL) > -1) {
        return (
          <React.Fragment key={key}>
            <PersonalURL
              tableHeadItem={tableHeadItem}
              firstUserInfoItem={firstUserInfoItem} />
          </React.Fragment>
        );
      } else if (tableHeadItem === Const.PERSONAL_USER_ID
          || tableHeadItem === Const.PERSONAL_FIRST_NAME
          || tableHeadItem === Const.PERSONAL_LAST_NAME
          || tableHeadItem === Const.PERSONAL_EMAIL
          || tableHeadItem === Const.PERSONAL_COUNTRY
          || tableHeadItem === Const.PERSONAL_AVATAR) {
        return null;
      } else {
        return(
          <React.Fragment key={key}>
            <PersonalItem
              tableHeadItem={tableHeadItem}
              firstUserInfoItem={firstUserInfoItem} />
          </React.Fragment>
        );
      }
    })
  );
  
}

const mapStateToProps = (state: State) => {
  return {
    getUserId: getUserId(state),
    firstUserInfoItem: firstUserInfoItem$(state),
    userInfoTableHeaders: userInfoTableHeaders$(state),
    preferenceItems: preferenceItems$(state),
    preferenceValue: preferenceValue$(state),
    percentageOfPreference: percentageOfPreference$(state),
  };
};

const mergeProps = (stateProps, dispatchProps: DispatchProps, props: OwnProps): Props => {
  return {
    ...stateProps,
    fetchFindUserAuthIdAction: dispatchProps.fetchFindUserAuthIdAction,
    fetchRefreshAuth: dispatchProps.fetchRefreshAuth,
    fetchMapShow: dispatchProps.fetchMapShow,
    ...props,
  };
};

export default connect(
  mapStateToProps, {
    fetchFindUserAuthIdAction: findUserActions.fetchFindUserAuthIdAction,
    fetchRefreshAuth: AuthCreators.fetchRefreshAuth,
    fetchMapShow: MapActions.fetchMapShow,
  }, mergeProps
  // @ts-ignore
)(React.memo(PersonalInformationTable));
